import React, { forwardRef } from "react";

import { Link } from "../../../utils/customLink";

import { dateFormat } from "../../../utils/dateFormat";

import ArrowRight from "images/icons/arrow-right.inline.svg";
import ShootingStar from "images/teen_scarcity.inline.svg";

// eslint-disable-next-line react/display-name
const StickyFooter = forwardRef(
  (
    {
      teenStickyDetails,
      applyNow,
      setOpenModal,
      containerRefClass = "bottom-0"
    },
    ref
  ) => {
    const dateMnth = dateFormat(
      {
        month: "long"
      },
      new Date()
    );

    const currentDate = new Date();
    const dateDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();

    const stickyDescription = teenStickyDetails?.description?.replace(
      "OFFER_DATE",
      [dateDay, dateMnth].join(" ")
    );

    if (!teenStickyDetails?.title && !teenStickyDetails?.description) {
      return <></>;
    }

    return (
      <>
        <div
          className={`fixed hidden md:flex ${containerRefClass} left-0 h-25 w-full border-t-[0.5px] border-gray-testimonial dark:bg-opacity-60 z-50 backdrop-blur-[20px] gvi-box-shadow transition-all duration-50  bg-white dark:!bg-gray-lighten/10 dark:gvi-blur-bg`}
          ref={ref}
        >
          <div className="gvi-container w-11/12 flex justify-between items-center mx-auto py-4 !px-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex flex-col">
                <div className="flex items-center gap-3">
                  <ShootingStar className="w-8 fill-yellow-lighten group-hover:fill-white dark:fill-white dark:group-hover:fill-gray-darker" />
                  <h1
                    dangerouslySetInnerHTML={{
                      __html: teenStickyDetails?.title
                    }}
                    className="text-xlrg-sm font-normal dark:font-semibold text-generic-text dark:text-white"
                  />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: stickyDescription
                  }}
                  className="text-md font-normal text-gray-generic"
                />
              </div>
              <div className="flex flex-col md:flex-row w-2/5 gap-3">
                <Link
                  className="submit-button group flex basis-1/2 justify-center items-center py-2"
                  to={applyNow}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: "Apply" }}
                    className="pr-2 font-bold"
                  />
                </Link>
                <Link
                  className="callback-button group flex basis-1/2 justify-center items-center py-2 bg-white hover:bg-black-lighter hover:text-white dark:bg-transparent dark:hover:bg-yellow dark:hover:text-gray-darker"
                  to={"#"}
                  onClick={() => {
                    setOpenModal(true);
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: "Free parent consultation"
                    }}
                    className="pr-2"
                  />
                  <ArrowRight className="dark:hidden block w-3 h-3 stroke-black-lighter dark:stroke-white group-hover:stroke-white group-hover:dark:stroke-black-lighter" />
                  <ArrowRight className="w-3 h-3 stroke-white group-hover:stroke-black-lighter hidden dark:block" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default StickyFooter;
